<template>
    <section class="tui-hint fix" v-if="showTip">
        <div class="opc"></div>
        <div class="dialog white1 br3 abs ct">
            <img class="fr cp" src="img/gen/ico_guanbi.png" @click="close()">
            <p>{{content}}</p>
            <div class="first fr cp" @click="confirm()">{{leftBtn}}</div>
            <div class="last fr cp" @click="cancel()">{{rightBtn}}</div>
        </div>
    </section>
</template>
<script>
import bus from "../../mixin/eventBus.js";
export default {
    data: function () {
        return {
            showTip: false,
            content: '确定要删除文件吗?',
            leftBtn: '确定',
            rightBtn: '取消',
            confirmAction: '', //确定之后的操作
            cancelAction: '', //取消之后的操作
        };
    },
    mounted() {

    },
    props: {

    },
    // mixins: [bus],
    methods: {
        show(options) {
            if (options) {
                this.content = options.content || this.content;
                this.leftBtn = options.leftBtn || this.leftBtn;
                this.rightBtn = options.rightBtn || this.rightBtn;
                this.confirmAction = options.confirmAction || "";
                this.cancelAction = options.cancelAction || "";
            }
            this.showTip = true;
        },
        confirm() {
            bus.$emit(this.confirmAction);
            this.close();
        },
        cancel() {
            bus.$emit(this.cancelAction);
            this.close();
        },
        close() {
            this.showTip = false;
        }
    }
};
</script>

<style scoped>
.tui-hint {
    width: 100%;
    height: 100%;
    z-index: 5;
}
.opc {
    width: 100%;
    height: 100%;
    background-color: #000;
}
.dialog {
    width: 335px;
    height: 162px;
    left: 428px;
    top: 200px;
    line-height: 26px;
}
.dialog img {
    padding: 16px;
}
.dialog p {
    margin-top: 55px;
}
.dialog div {
    margin-top: 46px;
}
.dialog p,
.dialog div {
    font-size: 14px;
    color: #464851;
}
.dialog .first {
    margin-right: 25px;
}
.dialog .last {
    margin-right: 35px;
}
</style>